import { useAppContext } from '../../Services/AppContext';
import GroupMemberAddPatientItem from './GroupMemberAddPatientItem';
import GroupMemberAddDoctorItem from './GroupMemberAddDoctorItem';
import AutocompleteV2 from '../AutocompleteV2/AutocompleteV2';
import apiClient from '../../Services/NetteApiClient';
import { useEffect, useState } from 'react';
import styles from './GroupMemberAddAutocomplete.module.scss';

export default function GroupMemberAddAutocomplete(props) {
	const [items, setItems] = useState([]);
	const [selectedSection, setSelectedSection] = useState(null);
	const [sections, setSections] = useState([]);
	const [searchValue, setSearchValue] = useState(null);
	const { translation } = useAppContext();

	const handleSearch = async (value, tempSelectedSection = null) => {
		setSearchValue(value);
		const tempSections = [];
		const tempItems = [];

		const { data: users } = await apiClient.get(
			`/user/patient-search/fulltext?autocomplete_query=${value}`,
		);
		let index = 0;
		for (const user of users) {
			if (tempSelectedSection || (!tempSelectedSection && index < 3)) {
				tempItems.push({
					...user,
					type: 'patient',
				});
			}
			index++;
		}

		tempSections.push({
			type: 'patient',
			label: translation['base.shared.patients'],
			showMore: index > 3,
		});

		const { data: doctors } = await apiClient.get(
			`/user/doctor-search/fulltext?autocomplete_query=${value}`,
		);
		index = 0;
		for (const doctor of doctors) {
			if (tempSelectedSection || (!tempSelectedSection && index < 3)) {
				tempItems.push({
					...doctor,
					type: 'doctor',
				});
			}
			index++;
		}

		tempSections.push({
			type: 'doctor',
			label: translation['base.doctors'],
			showMore: index > 3,
		});

		const { data: nurses } = await apiClient.get(
			`/user/doctor-search/fulltext?only_nurse=true&autocomplete_query=${value}`,
		);
		index = 0;
		for (const nurse of nurses) {
			if (tempSelectedSection || (!tempSelectedSection && index < 3)) {
				tempItems.push({
					...nurse,
					type: 'nurse',
				});
			}
			index++;
		}

		tempSections.push({
			type: 'nurse',
			label: translation['base.shared.nurses'],
			showMore: index > 3,
		});

		setSections(tempSections);

		setItems(tempItems);
	};

	const handleChange = value => {
		props.onChange && props.onChange(value);
	};

	const handleSectionSelect = section => {
		setSelectedSection(section);
		handleSearch(searchValue, section);
	};

	return (
		<AutocompleteV2
			inputPlaceholder={
				props.placeholder || translation['component.groupMsgs.chooseUser']
			}
			items={
				selectedSection
					? items.filter(i => i.type === selectedSection.type)
					: items
			}
			onSearch={handleSearch}
			onChange={handleChange}
			onSectionSelect={handleSectionSelect}
			selectedSection={selectedSection}
			sections={sections}
			className={styles.box}
			itemTemplate={props => {
				switch (props.item.type) {
					case 'patient':
						return <GroupMemberAddPatientItem {...props} user={props.item} />;
					case 'doctor':
						return <GroupMemberAddDoctorItem {...props} user={props.item} />;
					case 'nurse':
						return <GroupMemberAddDoctorItem {...props} user={props.item} />;
				}
			}}
		/>
	);
}
